// import { useState } from "react";
// import { useParams } from "react-router-dom";
// import { Search, SlidersHorizontal } from "lucide-react";
// import MachineCard from "../components/modules/machines/MachineCard";
// import machinesData from "../data/machinesData";

// const categories = ["All", "3D Printing", "CNC", "Laser Cutting", "PCB", "Moulding", "Robotics"];

// export default function Machines() {
//   const { city } = useParams(); // present only when navigated from a specific facility
//   const [query, setQuery] = useState("");
//   const [category, setCategory] = useState("All");

//   const filtered = machinesData.filter((m) => {
//     const matchesCity = city ? m.centre.toLowerCase() === city.toLowerCase() : true;
//     const matchesCategory = category === "All" || m.technology === category;
//     const matchesQuery =
//       m.name.toLowerCase().includes(query.toLowerCase()) ||
//       m.technology.toLowerCase().includes(query.toLowerCase()) ||
//       m.make.toLowerCase().includes(query.toLowerCase());
//     return matchesCity && matchesCategory && matchesQuery;
//   });

//   return (
//     <div>
//       {/* Header */}
//       <div className="bg-gradient-to-br from-[#1e1b4b] via-[#312e81] to-[#4c1d95] text-white rounded-2xl px-8 py-10 mb-6">
//         <span className="inline-block text-xs font-semibold bg-white/10 border border-white/20 rounded-full px-4 py-1.5 mb-4">
//           {city ? `APIC ${city}` : "Machine Marketplace"}
//         </span>
//         <h1 className="text-3xl md:text-4xl font-extrabold mb-2">
//           {city ? `Machines at APIC ${city}` : "340+ Machines. One platform."}
//         </h1>
//         <p className="text-indigo-100">
//           Book industrial 3D printers, CNC machines, laser cutters, PCB
//           prototypers and more.
//         </p>
//       </div>

//       {/* Search + filters */}
//       <div className="bg-white border border-gray-100 rounded-2xl p-3 flex flex-wrap items-center gap-3 mb-6">
//         <div className="flex items-center flex-1 min-w-[220px] gap-2 px-3">
//           <Search className="w-4 h-4 text-gray-400" />
//           <input
//             value={query}
//             onChange={(e) => setQuery(e.target.value)}
//             placeholder="Search machine, technology or make..."
//             className="w-full py-2.5 text-sm focus:outline-none"
//           />
//         </div>
//         <button
//           type="button"
//           className="flex items-center gap-2 border border-gray-200 rounded-xl px-4 py-2.5 text-sm font-medium hover:bg-gray-50"
//         >
//           <SlidersHorizontal className="w-4 h-4" />
//           Filters
//         </button>
//       </div>

//       {/* Category chips */}
//       <div className="flex flex-wrap gap-2 mb-6">
//         {categories.map((cat) => {
//           const isActive = category === cat;
//           return (
//             <button
//               key={cat}
//               type="button"
//               onClick={() => setCategory(cat)}
//               className={`text-sm font-medium px-4 py-2 rounded-full border transition ${
//                 isActive
//                   ? "bg-indigo-600 border-indigo-600 text-white"
//                   : "bg-white border-gray-200 text-gray-700 hover:border-indigo-300"
//               }`}
//             >
//               {cat}
//             </button>
//           );
//         })}
//       </div>

//       {/* Machine grid */}
//       {filtered.length > 0 ? (
//         <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
//           {filtered.map((machine) => (
//             <MachineCard key={machine.code} machine={machine} />
//           ))}
//         </div>
//       ) : (
//         <div className="h-48 flex items-center justify-center text-gray-400 border border-dashed border-gray-200 rounded-2xl">
//           No machines found.
//         </div>
//       )}
//     </div>
//   );
// }





import { useState } from "react";
import { useParams } from "react-router-dom";
import { Search, MapPin, Star } from "lucide-react";
import MachineCard from "../components/modules/machines/MachineCard";
import machinesData from "../data/machinesData";
import centresData from "../data/centersData";

const categories = ["All", "3D Printing", "CNC", "Laser Cutting", "PCB", "Moulding", "Robotics"];

export default function Machines() {
  const { city } = useParams(); // present only when navigated from a specific facility
  const [query, setQuery] = useState("");
  const [category, setCategory] = useState("All");

  const centre = city
    ? centresData.find((c) => c.city.toLowerCase() === city.toLowerCase())
    : null;

  const cityMachines = city
    ? machinesData.filter((m) => m.centre.toLowerCase() === city.toLowerCase())
    : machinesData;

  const availableCount = cityMachines.filter((m) => m.status === "Available").length;
  const categoryCount = new Set(cityMachines.map((m) => m.technology)).size;

  const filtered = cityMachines.filter((m) => {
    const matchesCategory = category === "All" || m.technology === category;
    const matchesQuery =
      m.name.toLowerCase().includes(query.toLowerCase()) ||
      m.technology.toLowerCase().includes(query.toLowerCase()) ||
      m.make.toLowerCase().includes(query.toLowerCase());
    return matchesCategory && matchesQuery;
  });

  return (
    <div>
      {/* Hero */}
      <div className="bg-gradient-to-br from-indigo-700 to-purple-700 text-white rounded-2xl px-8 py-8 mb-6">
        <div className="flex flex-wrap items-end justify-between gap-6">
          <div>
            {centre ? (
              <>
                <p className="flex items-center gap-1.5 text-sm text-indigo-100 mb-2">
                  <MapPin className="w-3.5 h-3.5" />
                  {centre.city}, Andhra Pradesh
                </p>
                <h1 className="text-3xl md:text-4xl font-extrabold mb-2">
                  APIC {centre.city}
                </h1>
                <p className="flex items-center gap-1.5 text-sm text-indigo-100">
                  <Star className="w-3.5 h-3.5 fill-white" />
                  {centre.rating} rating · {centre.experts} experts · {centre.utilised}% utilised
                </p>
              </>
            ) : (
              <>
                <span className="inline-block text-xs font-semibold bg-white/10 border border-white/20 rounded-full px-4 py-1.5 mb-4">
                  Machine Marketplace
                </span>
                <h1 className="text-3xl md:text-4xl font-extrabold mb-2">
                  340+ Machines. One platform.
                </h1>
                <p className="text-indigo-100">
                  Book industrial 3D printers, CNC machines, laser cutters, PCB
                  prototypers and more.
                </p>
              </>
            )}
          </div>

          {centre && (
            <div className="flex gap-8">
              <div className="text-center">
                <p className="text-2xl font-extrabold">{cityMachines.length}</p>
                <p className="text-[11px] tracking-wide text-indigo-200">MACHINES</p>
              </div>
              <div className="text-center">
                <p className="text-2xl font-extrabold">{availableCount}</p>
                <p className="text-[11px] tracking-wide text-indigo-200">AVAILABLE</p>
              </div>
              <div className="text-center">
                <p className="text-2xl font-extrabold">{categoryCount}</p>
                <p className="text-[11px] tracking-wide text-indigo-200">CATEGORIES</p>
              </div>
            </div>
          )}
        </div>
      </div>

      {/* Search + category chips (single card) */}
      <div className="bg-white border border-gray-200 rounded-2xl p-4 mb-6">
        <div className="flex items-center gap-2 border border-gray-200 rounded-xl px-3 mb-4">
          <Search className="w-4 h-4 text-gray-400" />
          <input
            value={query}
            onChange={(e) => setQuery(e.target.value)}
            placeholder={centre ? "Search this centre's machines..." : "Search machine, technology or make..."}
            className="w-full py-2.5 text-sm focus:outline-none bg-transparent"
          />
        </div>

        <div className="flex flex-wrap gap-2">
          {categories.map((cat) => {
            const isActive = category === cat;
            return (
              <button
                key={cat}
                type="button"
                onClick={() => setCategory(cat)}
                className={`text-sm font-medium px-4 py-1.5 rounded-full border transition ${
                  isActive
                    ? "bg-indigo-600 border-indigo-600 text-white"
                    : "bg-white border-gray-200 text-gray-700 hover:border-indigo-300"
                }`}
              >
                {cat}
              </button>
            );
          })}
        </div>
      </div>

      {/* Machine grid */}
      {filtered.length > 0 ? (
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {filtered.map((machine) => (
            <MachineCard key={machine.code} machine={machine} />
          ))}
        </div>
      ) : (
        <div className="h-48 flex items-center justify-center text-gray-400 border border-dashed border-gray-200 rounded-2xl">
          No machines found.
        </div>
      )}
    </div>
  );
}